import CarLoadMoreContainer from "../../../components/car/other/CarLoadMore";

const CarLoadMore = () => {
  return <CarLoadMoreContainer />;
};

export default CarLoadMore;
